<div [ngClass]="{ preview: preview }">
  <div [ngClass]="notificationType[notification.type]" class="notification-item d-flex align-items-start px-4 py-3">
    <div class="flex-grow-1 notification-item__body">
      <div [ngClass]="allowHide ? 'custom-padding' : 'pr-8'" class="notification-item__title semibold mb-1">
        <span>
          {{ notification.title }}
        </span>
      </div>
      <div class="caption mb-1 notification-item__description">
        <div [innerHTML]="notification.briefDescription | sanitizeRichText"></div>
        <div class="caption text-gray d-flex justify-content-end">
          @if (!preview && notification.type !== notificationType['Urgent alert']) {
            <div class="flex-grow-1">
              <span>{{ notificationSource[notification.notificationSource] }}</span>
              @if (notificationSource[notification.notificationSource] && notification.publishDate) {
                <span> &bull; </span>
              }
              <span>{{ notification.publishDate | dateAgo }}</span>
            </div>
          }

          @if (notification.description) {
            <button type="button" class="btn btn-link btn-sm" (click)="handleShowDetails(notification)">
              See details
            </button>
          }
        </div>
      </div>

      <div class="notification-item__actions d-flex">
        @if (allowHide) {
          <button
            type="button"
            class="btn btn-icon mt-n1 text-gray mx-1"
            (click)="handleHide(notification.notificationId)"
          >
            <i class="icon icon-eye-non-visible icon-12"></i>
          </button>
        }
        <button
          type="button"
          class="btn btn-icon mt-n1 text-gray"
          (click)="handleClose(notification.notificationId, $event)"
        >
          <i class="icon icon-close icon-16"></i>
        </button>
      </div>
    </div>
  </div>
</div>
